import React from 'react'
import { GlgTableRow, GlgTableCell, GlgLabel } from 'SharedComponents'
import PropTypes from 'prop-types'

const labelType = (status) => {
  switch (status){
    case 'sending':
      return 'warning'
    case 'delivered':
      return 'info'
    case 'opened':
      return 'success'
  }
}

const EmailDeliveryReportTableRow = ({...props}) => {
  return (
    <GlgTableRow { ...props } isSortable={ false }>
      <GlgTableCell>
        { props.player_name }
      </GlgTableCell>
      <GlgTableCell>
        { props.subject }
      </GlgTableCell>
      <GlgTableCell>
        <a data-toggle={'modal'} data-target={'#email_body_' + props.id} href={''}>
          { !window.I18n ? '' : window.I18n.t('marketing_campaigns.components.delivery_reports.email_delivery_report_table_row.view') }
        </a>
        <div className='modal fade' role={'dialog'} id={'email_body_' + props.id}>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h3 className='modal-title'>
                  { !window.I18n ? '' : window.I18n.t('marketing_campaigns.components.delivery_reports.email_delivery_report_table_row.email_body') }
                </h3>
              </div>
              <div className='modal-body white_background'>
                {props.body && (
                  <div dangerouslySetInnerHTML={{__html: props.body}} />
                ) || (
                  <p className='btsp_clear_text'>
                    { !window.I18n ? '' : window.I18n.t('marketing_campaigns.components.delivery_reports.email_delivery_report_table_row.no_content') }
                  </p>
                )}
              </div>
              <div className='modal-footer add-padding-right-30'>
                <a className='btsp_gray_button' data-toggle={'modal'} data-target={'#email_body_' + props.id}>
                  { !window.I18n ? '' : window.I18n.t('buttons.close').charAt(0)
                    .toUpperCase() + (!window.I18n ? '' : window.I18n.t('buttons.close').slice(1)) }
                </a>
              </div>
            </div>
          </div>
        </div>
      </GlgTableCell>
      <GlgTableCell>
        { props.to }
      </GlgTableCell>
      <GlgTableCell>
        <GlgLabel className='capitalize' type={labelType(props.status)}>
          { !window.I18n ? '' : window.I18n.t(`marketing_campaigns.components.delivery_reports.email_delivery_report_table_row.status.${props.status}`, {defaultValue: props.status}) }
        </GlgLabel>
      </GlgTableCell>
      <GlgTableCell>
        { props.opens || '0' }
      </GlgTableCell>
      <GlgTableCell>
        { props.clicks || '0' }
      </GlgTableCell>
      <GlgTableCell>
        { props.formatDate(new Date(props.updated_at)) }
      </GlgTableCell>
    </GlgTableRow>
  )
}

EmailDeliveryReportTableRow.propTypes = {
  id: PropTypes.number.isRequired,
  player_name: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  opens: PropTypes.string,
  clicks: PropTypes.string,
  updated_at: PropTypes.string.isRequired,
  formatDate: PropTypes.func.isRequired,
}

export default EmailDeliveryReportTableRow
